import { KForm, KTextField } from "kinnect-general";

export default KForm.extend( {
	name: "KAccountSettingsInfoForm",

	props: {
		formTitle: {
			...KForm.options.props.formTitle,
			default: "General Information"
		},

		redirect: {
			...KForm.options.props.redirect,
			default: () => ( { name: "account" } )
		},

		submitButtonText: {
			...KForm.options.props.submitButtonText,
			default: "Update My Info"
		}
	},

	data: () => ( {
		formFields: {
			email: null,
			phoneExtension: null
		}
	} ),

	computed: {
		user() {
			return this.$store.getters["auth/user"];
		},

		userID() {
			return this.$store.getters["auth/userID"];
		},

		emailNeedsChecked() {
			return !this.user.email
				|| ( this.formFields.email.trim() !== this.user.email.trim() );
		}
	},

	methods: {
		refetchUser() {
			this.$auth.fetch();
		}
	},

	created() {
		Object.keys( this.formFields ).forEach( key => {
			if ( this.user.hasOwnProperty( key ) ) {
				this.formFields[key] = this.user[key];
			}
		} );
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: `users/${this.userID}`,
				data: this.formFields,
				method: "put"
			}}
			on={{
				...this.$listeners,
				success: this.refetchUser
			}}
		>
			<KTextField
				disabled
				label="Name"
				prependIcon="person"
				vModel={this.user.name}
			></KTextField>

			<KTextField
				disabled
				label="Department"
				prependIcon="location_city"
				vModel={this.user.departmentNames}
			></KTextField>

			<KTextField
				label="Email*"
				prependIcon="email"
				required
				type="email"
				vModel={this.formFields.email}
				validationName="email"
				validationRules={{
					required: true,
					email: true,
					emailAvailable: this.emailNeedsChecked
				}}
			></KTextField>

			<KTextField
				label="Phone Extension"
				onInput={val => this.formFields.phoneExtension = val ? parseInt( val ) : null}
				prependIcon="phone"
				validationName="phoneExtension"
				validationRules="numeric"
				value={this.formFields.phoneExtension}
			></KTextField>
		</KForm>;
	}
} );
